import { Navigate } from 'react-router-dom'
import { useIsAdmin } from 'src/shared/hooks/useIsAdmin'
import { TEMP_AGENT_FORCE_LOGGED_IN } from 'src/shared/hooks/tempAgentAuthBypass'
import { paths } from 'src/routes/paths'
import { FullScreenLoader } from 'src/shared/components/FullScreenLoader'
import { useOrgUsersApi } from 'src/api/db/apiOrgUsers'

/** Sends SUPERADMIN staff from `/app` index to the admin dashboard. */
export const AdminAppRedirect = () => {
  const isAdmin = useIsAdmin()
  const { orgUser } = useOrgUsersApi()

  if (!TEMP_AGENT_FORCE_LOGGED_IN && (!orgUser || orgUser.status !== 200)) {
    return <FullScreenLoader />
  }

  if (isAdmin) {
    return <Navigate to={paths.admin} replace />
  }

  return <Navigate to={paths.myAccount + paths.dashboard} replace />
}
